// Client mirror of auth/server/lib/countryCodes.js (source of truth).
// Keep logic identical; only module syntax differs.

export const NAME_TO_ISO = {
  'Slovenia': 'SI', 'Avstrija': 'AT', 'Belgija': 'BE', 'Bolgarija': 'BG',
  'Bosna in Hercegovina': 'BA', 'Ciper': 'CY', 'Češka': 'CZ', 'Črna gora': 'ME',
  'Danska': 'DK', 'Estonija': 'EE', 'Finska': 'FI', 'Francija': 'FR',
  'Grčija': 'GR', 'Hrvaška': 'HR', 'Irska': 'IE', 'Islandija': 'IS',
  'Italija': 'IT', 'Latvija': 'LV', 'Lihtenštajn': 'LI', 'Litva': 'LT',
  'Luksemburg': 'LU', 'Madžarska': 'HU',
  'Malta': 'MT', 'Nemčija': 'DE', 'Nizozemska': 'NL', 'Norveška': 'NO',
  'Poljska': 'PL', 'Portugalska': 'PT', 'Romunija': 'RO',
  'Severna Makedonija': 'MK', 'Slovaška': 'SK', 'Srbija': 'RS',
  'Španija': 'ES', 'Švedska': 'SE', 'Švica': 'CH',
  'Velika Britanija': 'GB',
  // Non-European markets
  'Združene države Amerike': 'US', 'Japonska': 'JP',
  'Združeni arabski emirati': 'AE', 'Turčija': 'TR', 'Južna Afrika': 'ZA',
  'Brazilija': 'BR', 'Rusija': 'RU', 'Ukrajina': 'UA'
};

const ISO_CODES = new Set(Object.values(NAME_TO_ISO));

export function iso(nameOrCode) {
  if (!nameOrCode) return null;
  const raw = String(nameOrCode).trim();
  if (NAME_TO_ISO[raw]) return NAME_TO_ISO[raw];
  const up = raw.toUpperCase();
  if (up.length === 2 && ISO_CODES.has(up)) return up;
  return null;
}

export function vatPrefix(iso2) {
  if (!iso2) return null;
  return iso2 === 'GR' ? 'EL' : iso2;
}
